
import { useMutation } from "@tanstack/react-query";
import { claimTrip } from "@/utils/apiUtils";
import { useToast } from "@/hooks/use-toast";

interface TripClaimHandlerProps {
  onSuccess: () => void;
  children: (handleClaimTrip: (tripId: string) => void) => React.ReactNode;
}

const TripClaimHandler = ({ onSuccess, children }: TripClaimHandlerProps) => {
  const { toast } = useToast();
  
  const claimMutation = useMutation({
    mutationFn: claimTrip,
    onSuccess: () => {
      toast({
        title: "Trip claimed!",
        description: "You have successfully claimed this trip.",
      });
      onSuccess();
    },
    onError: (error) => {
      toast({
        title: "Failed to claim trip",
        description: error.message || "An error occurred while claiming the trip.",
        variant: "destructive",
      });
    }
  });
  
  const handleClaimTrip = (tripId: string) => {
    claimMutation.mutate(tripId);
  };
  
  return <>{children(handleClaimTrip)}</>;
};

export default TripClaimHandler;
